


import TiwiMixin from '../mixins/TiwiMixin'

import _ from 'lodash';

export default {
  mixins: [TiwiMixin],
  components: {
    
  },
  props: {
    title: {
      type: String,
      default: 'Notifiche'
    },
    titleIcon: {
      type: String,
      default: 'icon-bell'
    },
  },
  data() {
    return {
      notifications: null,
    }
  },
  mounted: function () {
    
    this.getNotifications();

    var self = this;
    this.timer  = setInterval( function(){
      self.getNotifications();
    }, 30000);

  },
  computed: {

  },
  methods: {
    getNotifications(){

    

    var self = this;
    self.setLoading(true);

    this.api.get('wall/getNotifications')
      .then((response) => {
        if (response.data.success) {
          self.notifications =  response.data.notifications; 
          
        }
        else {
          self.toast.error(response.data.message);
        }
      })
      .catch((error) => {
        self.toast.error('Errore nella richiesta');
      })
      .finally(() => self.setLoading(false))

   },
  
  },
  watch: {

  }
}
